import { FC } from 'react';
// Model
import ILabel from 'app/models/Label';
// Mui
import { Box, Chip, SxProps } from '@mui/material';
// framer-motion
import { AnimatePresence, motion } from 'framer-motion';

type Props = {
  id: number | string;
  labels: (ILabel & { status?: string })[] | undefined;
  onRemove?: (index:number) => void;
  sx?: SxProps;
};

const Labels:FC<Props> = ({
  // Props
  id, labels, onRemove, sx = { display: 'flex', flexWrap: 'wrap', gap: 2 }
}) => {
  if ( !labels || !labels.length ) return null;
  return (
    <Box sx={sx}>
      <AnimatePresence>
        {labels.map((label, index) => {
          const sameLabels = labels.filter(l => l.name === label.name && l.color === label.color);
          const position = sameLabels.length > 1 ? labels.slice(0, index).filter(l => l.name === label.name && l.color === label.color).length : 0;
        
          const key = `${id}-label-item-${label.name}-${label.color}-${position}`;
          return ((
            <motion.div
              key={key}
              initial={label.status === 'addedByOther' ? { opacity: 0, scale: 0.8 } : false}
              animate={{ opacity: 1, scale: 1 }}
              exit={label.status === 'removedByOther' ? { opacity: 0, scale: 0.8 } : undefined}
              transition={{ duration: 1 }}
            >
              <Chip
                className={label.color}
                sx={{
                  userSelect: 'text',
                  borderRadius: '4px !important',
                  py: '8px !important',
                  px: '12px !important',
                  '& .MuiChip-label': {
                    padding: '0 !important',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '16px'
                  },
                  '& .MuiChip-deleteIcon': {
                    margin: '0 -4px 0 8px'
                  }
                }}
                // If clicked on Sidabar on file item and hover on `Chip` it throw an error: `_onClick is not a function`
                // Temporary fix: return;
                onClick={() => {
                  return;
                }}
                label={label.name}
                onDelete={typeof onRemove !== 'undefined' ? () => onRemove(index) : undefined}
              />
            </motion.div>
          ))
        })}
      </AnimatePresence>
    </Box>
  )
}

export default Labels;